module.exports = __webpack_public_path__ + "img/ics_o_package-crrotw.0a15f70c.svg";